import React from 'react';
import PropTypes from 'prop-types';

const ProjectRow = ({ name, type, href }) => (
  <div className="projectRow">
    <h2 className="link">
      <a href={href}>{name}</a>
    </h2>
    <div>{type}</div>
  </div>
);

ProjectRow.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
};

export default ProjectRow;



// WEBPACK FOOTER //
// ./src/Modules/MoreProjects/ProjectRow.js